module.exports = __webpack_public_path__ + "img/s4.18293f80.jpg";